import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import '../../assets/stylesheets/ProfileSlide/ProfileSettings.scss';
import OptionRow from './OptionRow';
import profileSettings from '../../config/profile';
import DialogHeader from '../../components/Units/Header'
import { soundToggle } from '../../store/actionCreators/profileSettings';

const Settings = ({}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const soundIsEnabled = useSelector(state => state.soundEnabled);
    const toggleSound = useCallback(() => {
        dispatch(soundToggle());
    });
    const settings = profileSettings.settings;

    return (
        <div className={'profileSettings'}>
            <DialogHeader title='settingsTitle' backTo={'/profile'}/>
            <div className="mainContainer">
                <div className={'optionRow sound'}>
                    <div className='soundOption' onClick={() => toggleSound()}>
                        <span className="title">{t('soundEffects')}</span>
                        <div className={`switchBox`} >
                            <span className={`fa toggle-${soundIsEnabled ? 'on' : 'off'}`}></span>
                        </div>
                    </div>
                </div>
                {
                    settings.map((option, index) => <OptionRow key={index} option={option} section='settings'></OptionRow>)
                }
            </div>

        </div>
    );
};

export default Settings;
